import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { InfoIcon } from '@components/InfoIcon'
import { SelectFormControlLabel } from '@modules/search/index.styles'
import { MetaFilterTypes } from '@modules/search/types'
import { Box, Checkbox, Typography } from '@mui/material'

export const NewItemsSelectFilter = ({
  value,
  handleSelectNewItemsFilter,
}: {
  value: boolean
  handleSelectNewItemsFilter?: (isSelected: boolean) => void
}) => {
  const { t } = useTranslation()

  const handleClick = () => {
    handleSelectNewItemsFilter?.(!value)
  }
  return (
    <SelectFormControlLabel
      key={MetaFilterTypes.BY_NEW_ITEMS}
      value={MetaFilterTypes.BY_NEW_ITEMS}
      control={<Checkbox checked={value} onClick={handleClick} />}
      label={
        <Box display="flex" flexDirection="row" gap="7px">
          <Typography variant="body2">{t(translationKeys.NEW_ITEMS_LABEL)}</Typography>
          <InfoIcon title={t(translationKeys.NEW_ITEMS_DESCRIPTION)} />
        </Box>
      }
      sx={{ alignItems: 'center' }}
    />
  )
}
